/**
 * Returns float value.
 * Parse string with comma as decimal separator to float.
 *
 * @param value the value to parsing.
 * @returns float value.
 */
export function stringToFloat(value) {
    let valueWithoutPoints = value.split(".").join("");
    return parseFloat(valueWithoutPoints.replace(",", "."));
}

/**
 * Returns string parsed from number, with comma as separator and two fixed digits after comma.
 *
 * @param value the value to parsing.
 * @returns see description.
 */
export function floatToString(value) {
    return value.toLocaleString('de-DE', {minimumFractionDigits: 2, maximumFractionDigits: 2});
}


// WEBPACK FOOTER //
// ./src/utils/Number.js